<template>
  <div>
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <canvas
      id="chartComparativoPrecoMedioleite"
      width="150"
      height="70"
    />
    <div
      v-if="true"
      id="legendaComPrecoMedio"
      class="text-center px-3"
    >
      <v-row
        align="center"
        class="ma-0"
      >
        <v-avatar
          class="mr-1"
          color="#4780b8"
          size="10"
        />
        <span class="mr-3 font-weight-light">Preço médio de leite ano Anterior</span>
        <v-avatar
          class="mr-1"
          color="#ed934f"
          size="10"
        />
        <span class="mr-3 font-weight-light">Preço médio de leite ano atual</span>
      </v-row>
    </div>
  </div>
</template>
    <script>
  import Chart from 'chart.js'
  import EntregaLeite from '../../../../services/entregaleite'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'DashboardComparativoPrecoMedioLeite',
    components: {
    },

    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      colors: [],
      myChart: {},
      empresaSelect: [],
      linhaSelect: [],
      loading: false,
      error: null,
      exibirLegenda: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      myChart1: {},
      styleObjectvalorRestante: {
        color: '#ed934f',
      },
      montarGrafico: true,
      text: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      date: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
    }),

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, empresaSelect, linhaSelect) {
        this.primeiroDia = primeiroDia
        this.date = ultimoDia
        this.empresaSelect = empresaSelect
        this.linhaSelect = linhaSelect

        this.atualizaGrafico()
      },

      async atualizaGrafico () {
        this.loading = true

        this.exibirLegenda = false

        if (this.myChart.data) {
          this.myChart.destroy()
        }

        await EntregaLeite.showComparativoPrecoMedioLeite(this.primeiroDia, this.date, this.empresaSelect, localStorage.tokencontrato, this.linhaSelect).then(resposta => {
          if (resposta.data.status) {
            const ctx = document.getElementById('chartComparativoPrecoMedioleite').getContext('2d')

            var anoAtual = parseFloat((resposta.data?.datasprecoMedioAtual?.[0]?.split('-')[1]) || 0)
            var anoAnterior = parseFloat((resposta.data?.datasprecoMedioAnterior?.[0]?.split('-')[1]) || 0)
            var footer = resposta.data?.datasprecoMedioAtual?.map((meses) => meses?.split('-')[0] || 0) || []

            this.myChart = new Chart(ctx, {
              type: 'bar',
              data: {
                labels: footer,
                datasets: [
                  {
                    label: 'preço medio do Ano Anterior',
                    data: resposta.data.precoMedioLeiteAnterior,
                    backgroundColor: '#4780b8',
                    order: 1,
                  },
                  {
                    label: 'Preço medio',
                    data: resposta.data.precoMedioLeiteAtual,
                    backgroundColor: '#ed934f',
                    order: 2,
                  },
                ],
              },
              options: {
                scales: {
                  y: {
                    beginAtZero: true,
                  },
                  xAxes: [{
                    gridLines: {
                      display: false,
                    },
                  }],
                  yAxes: [{
                    ticks: {
                      min: 0,
                    },
                    gridLines: {
                      display: false,
                    },
                    display: false,
                  }],
                },
                low: 50,
                high: 5,
                legend: {
                  display: false,
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
                      return value
                    },
                    title: (tooltipItem) => {
                      if (tooltipItem[0].datasetIndex === 0) {
                        return tooltipItem[0].xLabel + '/' + anoAnterior
                      } else {
                        return tooltipItem[0].xLabel + '/' + anoAtual
                      }
                    },
                  },
                },
              },
            })
          } else if (resposta.data.msg === 'Não há dados para comparar com o filtro selecionado') {
            this.text = resposta.data.text

            if (this.myChart.data) {
              this.myChart.destroy()
            }

            this.showSnackbar('error', 3000, resposta.data.text)
          }
        }).catch(e => {
          console.error('erro', e.message)
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.text === 'Contrato não encontrado') {
            this.error = e.data.text
            this.showSnackbar('error', 3000, e.data.text)
          }
        }).finally(f => {
          this.loading = false

          this.exibirLegenda = true
        })
      },
      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
  </script>
  <style lang="sass">
  #legendaComPrecoMedio
    font-size: 12px
    margin: 1rem 0 0 -1rem
    text-align: left !important

  .legendaComPrecoMedio
    font-size: 9px
    margin: 0 0 0 -1rem
  </style>

  <style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-webkit-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @-o-keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
    @keyframes loader
      from
        transform: rotate(0)
      to
        transform: rotate(360deg)
  }

  @media screen and (min-device-width: 320px) and (max-device-width: 560px) {
    #myChart7 {
      margin: -5rem 0 0 0;
      width: 400px !important;
      height: 175px !important;
    }

    #legendaComPrecoMedio {
      font-size: 9px !important;
      margin: 0 0 0 -1rem !important;
    }
  }

  @media screen and (min-width: 600px) and (max-width: 1000px) and (-webkit-min-device-pixel-ratio: 1) {
    #myChart7 {
      margin: -3rem 0 0 6rem;
      width: 780px !important;
      height: 364px !important;
    }

    #legendaComPrecoMedio {
      font-size: 12px !important;
      margin: 1rem 0 0 7rem !important;
      text-align: left !important;
    }
  }
</style>
